import React, { useMemo } from 'react';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';
import shadows, { customShadows } from './shadows';
import { transitions, easing } from './animations';
import { createComponentOverrides } from './overrides';
import useSettings from '../hooks/useSettings';

const ThemeProvider = ({ children }) => {
  const { themeMode } = useSettings();

  const theme = useMemo(() => {
    const baseTheme = createTheme({
      palette: palette[themeMode],
      typography,
      breakpoints,
      shadows: shadows[themeMode],
      customShadows: customShadows[themeMode],
      shape: {
        borderRadius: 12,
      },
      transitions: {
        duration: transitions,
        easing,
        create: (props, options) => {
          const propsArray = Array.isArray(props) ? props : [props];
          const {
            duration = transitions.standard,
            easing: easingFunction = easing.easeInOut,
            delay = 0,
          } = options || {};
          
          return propsArray
            .map(prop => `${prop} ${duration}ms ${easingFunction} ${delay}ms`)
            .join(', ');
        },
      },
    });
    
    // 应用组件覆盖
    baseTheme.components = createComponentOverrides(baseTheme);
    
    return baseTheme;
  }, [themeMode]);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
};

export default ThemeProvider;
